import React from 'react';
import Table, { columnType } from '../../../components/ClearingTable/Table';
import Button from '../../../components/Buttons/Button';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountNo from '../../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteBranch from '../../../components/AutoComplete/AutoCompleteBranch';
import Text from '../../../components/Typography/Text';
import { notifyInfo, notifyError } from '../../../components/Messages/Notification';
import DownloadProgress from '../../../components/Progress/DownloadProgress';
import { TextField } from '@material-ui/core';
import QueryParam from '../../../services/QueryParamService';
import { IconButton, Tooltip } from '@material-ui/core';
import { Visibility as ViewIcon } from '@material-ui/icons';
import {
  listForm1099Int,
  downloadInt,
  generateInt,
} from '../../../services/Form1099INTService';
import Form1099INTModal from '../../../components/Modals/Form1099INTModal';
import { CustomBodyRenderCurrencyLeft } from '../../../components/Table/CustomBodyRender';

export default function Form1099INT() {
  let selectedIndexes = [];
  const [rows, setRows] = React.useState([]);
  const [rowData, setRowData] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      year: '',
      correspondent: '',
      branch: '',
      accountNo: '',
    })
  );
  const [openModal, setOpenModal] = React.useState(false);

  // Table Settings
  const form1099BColumns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div align={'left'} className="grd-row" style={{ margin: 0, padding: 0 }}>
              <div align={'left'} className="grd-cell" style={{ display: 'flex' }}>
                <DownloadProgress
                  selected={rows[dataIndex]}
                  fileType="pdf"
                  rows={rows}
                  download={downloadInt}
                  generate={generateInt}
                  useSystemUpdateIcon={false}
                  tooltip={'Download PDF'}
                />

                <DownloadProgress
                  selected={rows[dataIndex]}
                  fileType="csv"
                  rows={rows}
                  download={downloadInt}
                  generate={generateInt}
                  useSystemUpdateIcon={true}
                  tooltip={'Download CSV'}
                />

                <Tooltip title="View" arrow>
                  <IconButton
                    aria-label="view"
                    onClick={() => {
                      handleOpenModal(dataIndex);
                    }}
                  >
                    <ViewIcon style={{ height: 25, width: 25 }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: 'year',
      label: 'Year',
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'taxCountry',
      label: 'Tax Country',
    },
    {
      name: 'intt',
      label: 'Interest',
      options: {
        customBodyRender: CustomBodyRenderCurrencyLeft,
      },
    },
    {
      name: 'accountName',
      label: 'Account Name',
      options: {
        display: false,
      },
    },
    {
      name: 'address',
      label: 'Address',
      options: {
        display: false,
      },
    },
    {
      name: 'city',
      label: 'City',
      options: {
        display: false,
      },
    },
    {
      name: 'state',
      label: 'State',
      options: {
        display: false,
      },
    },
    {
      name: 'zip',
      label: 'Zip',
      options: {
        display: false,
      },
    },
    {
      name: 'country',
      label: 'Country',
      options: {
        display: false,
      },
    },
    {
      name: 'legalEntity',
      label: 'Legal Entity',
      options: {
        display: false,
      },
    },
    {
      name: 'governmentIdType',
      label: 'Government ID Type',
      options: {
        display: false,
      },
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    responsive: 'standard',
    customToolbarSelect: (selectedRows) => {
      return (
        <div className="grd-row" style={{ marginRight: 15, padding: 0 }}>
          <div className="grd-cell" style={{ marginRight: 15 }}>
            <Button
              id="batch"
              disabled={loading}
              loading={loading}
              type="download"
              label={'BATCH DOWNLOAD PDF'}
              onClick={() => {
                handleBatchDownload('pdf');
              }}
            />
          </div>
          <div className="grd-cell" style={{ whiteSpace: 'nowrap' }}>
            <Button
              id="batch"
              disabled={loading}
              loading={loading}
              type="download"
              label={'BATCH DOWNLOAD CSV'}
              onClick={() => {
                handleBatchDownload('csv');
              }}
            />
          </div>
        </div>
      );
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      console.log(allRowsSelected);
      let tempIds = [];

      allRowsSelected.map((row) => {
        tempIds.push(row.index);
      });

      selectedIndexes = tempIds;
    },
  };
  // End Table Settings

  const init = async () => {
    const searchParameters = localStorage.getItem('search_data');

    const { year, correspondent, branch, accountNo } = searchParameters
      ? JSON.parse(searchParameters)
      : searchData;

    setSearchData({
      ...searchData,
      year: year ? year : '',
      correspondent: correspondent ? correspondent : '',
      branch: branch ? branch : '',
      accountNo: accountNo ? accountNo : '',
    });
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async () => {
    try {
      setLoading(true);

      QueryParam.set(searchData);
      const { form1099IntList } = await listForm1099Int(searchData);
      setRows(form1099IntList);

      notifyInfo(form1099IntList.length + ' search results.');
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBatchDownload = async (fileType) => {
    try {
      setLoading(true);
      for (let i = 0; i < selectedIndexes.length; i++) {
        await downloadInt(rows[selectedIndexes[i]], fileType, '', '');
      }
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (selectedRow) => {
    setRowData(rows[selectedRow]);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Form 1099 INT" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <TextField
              fullWidth={true}
              name="year"
              label="Year"
              type="number"
              value={searchData.year}
              onChange={handleSearchDataChange}
              inputProps={{ maxLength: 300 }}
              InputLabelProps={{ shrink: true }}
              disabled={false}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteCorrespondent
              isAccessibleOnly={true}
              isAllStatus={true}
              name="correspondent"
              value={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteBranch
              isAccessibleOnly={true}
              isAllStatus={true}
              name="branch"
              value={searchData.branch}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountNo
              isAccessibleOnly={true}
              isAllStatus={true}
              name="accountNo"
              value={searchData.accountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Form 1099 INT'}
          data={rows}
          columns={form1099BColumns}
          options={options}
        />
        {openModal && (
          <Form1099INTModal open={openModal} close={closeModal} data={rowData} />
        )}
      </div>
    </form>
  );
}
